export default __webpack_public_path__ + "static/media/card-front-shaped-final.95da2c53.svg";